import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import Header from "../components/Header.js";
import Footer from "../components/Footer.js";
import Countdown, { zeroPad } from "react-countdown";
import $ from "jquery";
import { toast } from "react-toastify";
import Select from "react-select";
import Web3 from "web3";
import "@metamask/legacy-web3";
import config from "../lib/config";
import Single_ABI from "../ABI/BEP721.json";
import Multiple_ABI from "../ABI/BEP1155.json";
import collection_Multiple_ABI from "../ABI/collection1155";
import collection_Single_ABI from "../ABI/collection721"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import ConnectWallet from "./separate/Connect-Wallet";
import { ParamAccountAddr_Detail_Get, getCurAddr } from "../actions/v1/user";
import {
  GetCategoryAction,
  CreateTokenValidationAction,
  CreateCollectionValidationAction,
  TokenAddItemAction,
  TokenAddOwnerAction,
  TokenCount_Get_Action,
  ipfsImageHashGet,
  ipfsmetadatafunciton,
  getwhitelist,
  CollectiblesList_Home,
  Collection_Create,
  GetCollections,
  addapprove,
  getapprove,
} from "../actions/v1/token";

// Scroll to Top
function ScrollToTopOnMount() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return null;
}
toast.configure();
let toasterOption = config.toasterOption;

export default function Create() {
  const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isFocused ? "null" : null,
      };
    },
  };
  var myDate = new Date();
  var newdat = myDate.setDate(myDate.getDate() + parseInt(1));
  var initialEnd = new Date(newdat);
  const [UserAccountAddr, Set_UserAccountAddr] = React.useState("");
  const [AddressUserDetails, Set_AddressUserDetails] = useState({});
  const [Accounts, Set_Accounts] = React.useState("");
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [StartDate, Set_StartDate] = useState("Right after listing");
  const [EndDate, Set_EndDate] = useState("1 Day");
  const [Clocktime, set_Clocktime] = useState("");
  const [EndClocktime, set_EndClocktime] = useState(initialEnd);
  const [CategoryOption, setCategoryOption] = useState(0);
  const [collectioncategory, setCollectioncategory] = useState({ label: "" });
  const [collectioncategoryname, setCollectioncategoryname] =
    useState("Select");
  const [currencyName, setcurrencyName] = useState("ETH");
  const [currency, setcurrency] = useState({ label: "" });
  const [contractAddress, setcontractAddress] = useState(config.singleContract);
  const [TokenCategory, setTokenCategory] = useState({ label: "" });
  const [tokenCategory, settokenCategory] = useState("");
  const [TokenFile, setTokenFile] = useState("");
  const [TokenFilePreReader, setTokenFilePreReader] = useState("");
  const [TokenFilePreUrl, setTokenFilePreUrl] = useState("");
  const [PutOnSaleType, setPutOnSaleType] = useState("putonmarket");
  const [DefaultCollection, setDefaultCollection] =
    useState("defaultCollection");
  const [PutOnSale, setPutOnSale] = useState(false);
  const [MinimumBid, Set_MinimumBid] = useState(0);
  const [MaximumBid, Set_MaximumBid] = useState(0);
  const [TokenPrice, setTokenPrice] = useState(0);
  const [Price, setPrice] = useState(0);
  const [YouWillGet, Set_YouWillGet] = useState(0);
  const [TokenName, setTokenName] = useState("");
  const [ValidateError, setValidateError] = useState({ TokenPrice: "" });
  const [tokenWill, setTokenWill] = useState(0);
  const [TokenDescription, setTokenDescription] = useState("");
  const [TokenRoyalities, setTokenRoyalities] = useState(5);
  const [TokenProperties, setTokenProperties] = useState("");
  const [UnLockcontent, Set_UnLockcontent] = useState("");
  const [TokenQuantity, Set_TokenQuantity] = useState(1);
  const [Unlockoncepurchased, Set_Unlockoncepurchased] = useState(false);
  const [FormSubmitUserClicked, Set_FormSubmitUserClicked] = useState(false);
  const [UserAccountBal, Set_UserAccountBal] = useState(0);
  const [ApproveCallStatus, setApproveCallStatus] = useState("init");
  const [MintCallStatus, setMintCallStatus] = useState("init");
  const [SignCallStatus, setSignCallStatus] = useState("init");
  const [SignLockCallStatus, setSignLockCallStatus] = useState("init");
  const [ipfsmetatag, set_ipfsmetatag] = useState("");
  const [ipfshash, setIpfsHash] = useState("");
  const [ipfshashurl, setipfshashurl] = useState("");
  const [TokenCount, Set_TokenCount] = useState(0);
  const [MintHashVal, Set_MintHashVal] = useState("");
  const [whitelistadmin, setWhitelistadmin] = useState("");
  const [useraddress, setUseraddress] = useState("");
  const [CollectiblesType, setCollectiblesType] = useState("Single");
  const [Categoryname, setCategoryname] = useState("Select");
  const [photo, Set_photo] = useState("");
  const [userimage, Set_userimage] = useState("");
  const [owncollectionname, set_owncollectionname] = useState("");
  const [owncollectionsymbol, set_owncollectionsymbol] = useState("");
  const [collectiondescription, set_collectiondescription] = useState("");
  var imageUrl = config.Back_URL + "images/previewThumb.png";
  const [profileimage, setprofileimage] = useState(imageUrl);
  const [collectionurl, set_collectionurl] = useState(
    "http://212.71.233.123/pyramidionscollection/"
  );
  const [WalletConnected, setWalletConnected] = React.useState(false);
  const [showloadercollect, Set_showloadercollect] = useState(false);
  const [CollectibleType, Set_CollectibleType] = useState(721);
  const [ContractAddressUser, set_ContractAddressUser] = React.useState("");
  const [ownsinglecontract, setownsinglecontract] = useState("");
  const [customcollection, setcustomcollection] = React.useState("");
  const [ownmultiplecontract, setownmultiplecontract] = useState("");
  const [mainnet, setmainnet] = React.useState(false);
  const [collectionlist, set_collectionlist] = React.useState(0);
  const [bidprice, set_bidprice] = React.useState(0);
  const [profilestatus, setprofilestatus] = React.useState(false);
  const [putonmarket, setputonmarket] = React.useState(false);
  const [userApproved, setUserApproved] = React.useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  useEffect(() => {
    loadInitialDatas();
  }, []);

  async function loadInitialDatas() {
    await loadScript();
    await GetCategoryCall();
    await getWhitelistAdmin();
    await GetUserCollections("", "");
    await Get_MyItemAccountAddr_Details();
  }

  let Collectionsoptions = [];

  const handleFilecollection = (event) => {
    event.preventDefault();
    const { id, files } = event.target;
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      var url = reader.readAsDataURL(event.target.files[0]);
      var file = event.target.files[0];
      Set_photo(file);
      reader.onloadend = function (e) {
        Set_userimage(reader.result);
      }.bind(this);
    }
  };

  async function GetUserCollections(currAddr, type) {
    setCollectioncategoryname("Select");
    set_collectionlist("");
    var newType = type == "" ? CollectibleType : type;
    var web3 = new Web3(window.ethereum);
    const getaccounts = await web3.eth.getAccounts();
    currAddr = getaccounts[0];

    Collectionsoptions = [];
    var response = await GetCollections({
      useraddress: currAddr,
      type: newType,
      contractadd: ContractAddressUser,
    });
    if (
      response &&
      response.data &&
      response.data.RespData &&
      response.data.RespData.length > 0
    ) {
      var collectionarray = response.data.RespData;
      if (collectionarray.length > 0) {
        for (let i = 0; i < collectionarray.length; i++) {
          var datas = {
            name: "collectioncategory",
            value: collectionarray[i].conAddr,
            label: collectionarray[i].symbol,
          };
          Collectionsoptions.push(datas);
        }

        set_collectionlist(Collectionsoptions);
      } else {
        var datas = {
          value: "No Record",
          name: "collectioncategory",
          label: "No Record",
        };
        Collectionsoptions.push(datas);
        set_collectionlist(Collectionsoptions);
      }
    } else {
      var datas = {
        value: "No Record",
        name: "collectioncategory",
        label: "No Record",
      };
      Collectionsoptions.push(datas);
      set_collectionlist(Collectionsoptions);
    }
  }

  const inputChangename = async (e) => {
    set_owncollectionname(e.target.value);
  };

  const inputChangesymbol = async (e) => {
    set_owncollectionsymbol(e.target.value);
  };

  const inputChangedescription = async (e) => {
    set_collectiondescription(e.target.value);
  };

  const inputChangeurl = async (e) => {
    set_collectionurl(e.target.value);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (window.ethereum) {
      var web3 = new Web3(window.ethereum);
      try {
        if (typeof web3 !== "undefined") {
          await window.ethereum
            .enable()
            .then(async function () {
              const web3 = new Web3(window.web3.currentProvider);
              if (window.web3.currentProvider.isMetaMask === true) {
                if (
                  window.web3 &&
                  window.web3.eth &&
                  window.web3.eth.defaultAccount
                ) {
                  setWalletConnected(true);
                  if (
                    window.web3.currentProvider.networkVersion ==
                    config.networkVersion
                  ) {
                    var result = window.web3.eth.defaultAccount;
                    setUseraddress(result);
                    var currAddr = result;
                    Set_showloadercollect(true);
                    if (owncollectionname == "") {
                      toast.error(
                        "Please Enter the Collection Name",
                        toasterOption
                      );
                      Set_showloadercollect(false);
                      return false;
                    }
                    if (owncollectionsymbol == "") {
                      toast.error(
                        "Please Enter the Collection Symbol",
                        toasterOption
                      );
                      Set_showloadercollect(false);
                      return false;
                    }
                    if (photo == null || photo == "" || photo == undefined) {
                      toast.error(
                        "Please Choose the Collection Image",
                        toasterOption
                      );
                      Set_showloadercollect(false);
                      return false;
                    }
                    if (collectionurl == "") {
                      toast.error(
                        "Please Enter the Collection Url",
                        toasterOption
                      );
                      Set_showloadercollect(false);
                      return false;
                    }

                    var jsonabi = collection_Multiple_ABI;
                    var byteCode =
                      "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";
                    let payload = {
                      arguments: [
                        1,
                        currAddr,
                        config.multipleContract,
                        config.tokenSymbol,
                        config.tokenAddress,
                        config.owntokenSymbol,
                        config.esctokenAddr,
                        owncollectionname,
                        owncollectionsymbol,
                      ],
                    };
                    if (CollectibleType == 721) {
                      var jsonabi = collection_Single_ABI;
                      var byteCode =
                        "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";
                      let payload = {
                        arguments: [
                          1,
                          currAddr,
                          config.singleContract,
                          config.tokenSymbol,
                          config.tokenAddress,
                          config.owntokenSymbol,
                          config.esctokenAddr,
                          owncollectionname,
                          owncollectionsymbol,
                        ],
                      };
                    }
                    var servicefee = config.fee;
                    var randomtokenid = Math.floor(Date.now() / 1000);
                    try {
                      var mychoice = localStorage.getItem("choice");
                      var deploy_contract = await new web3.eth.Contract(
                        jsonabi
                      );
                      deploy_contract.options.data = "0x" + byteCode;
                      let account = currAddr;
                      let type = config.tokenname;
                      var tokenadd = config.WMATICaddress;
                      let parameter = {
                        from: account,
                      };
                      // let payload = {
                      //   arguments: [1, servicefee.toString(), currAddr],
                      // };

                      deploy_contract
                        .deploy(payload)
                        .send(parameter, (err, transactionHash) => {
                          console.log(
                            err,
                            "errerrerrerrerrerrerr",
                            transactionHash
                          );
                        })
                        .on("confirmation", () => {})
                        .then(async (newContractInstance) => {
                          var bep20 = newContractInstance.options.address;
                          set_ContractAddressUser(bep20);
                          if (CollectibleType == 721) {
                            setownsinglecontract(bep20);
                            //  var newnftsingle = new web3.eth.Contract(singleabi,bep20);
                            //  var fee1 = parseFloat(singlefee)*1000000000000000000
                            //  var restt = await newnftsingle.methods.serviceFunction(fee1.toString()).send({
                            //    from: result[0]
                            //  });
                            // var token = "["+config.tokenname+"]"
                            //  var restt = await newnftsingle.methods.addTokenType(token.toString(),config.WMATICaddress).send({
                            //    from: result[0]
                            //  });
                            var payload = {
                              useraddress: currAddr,
                              newcontract: bep20,
                              collectionname: owncollectionname,
                              collectionsymbol: owncollectionsymbol,
                              collectiondescription: collectiondescription,
                              imageUser: photo,
                              type: CollectibleType,
                              url: collectionurl.replace(
                                "http://212.71.233.123/pyramidionscollection/",
                                ""
                              ),
                            };

                            var collectionresp = await Collection_Create(
                              payload
                            );
                            if (collectionresp.data.status) {
                              setcustomcollection(bep20);
                              Set_showloadercollect(false);
                              window
                                .$("#choose_collection_modal")
                                .modal("hide");
                              GetUserCollections(currAddr, "");
                              toast.success(
                                "Collection created",
                                toasterOption
                              );
                            } else {
                              Set_showloadercollect(false);
                              toast.error(
                                "error",
                                "Server Error",
                                toasterOption
                              );
                            }
                          } else {
                            setownmultiplecontract(bep20);
                            //  var fee1 = parseFloat(multiplefee)*1000000000000000000
                            //  var newnftsingle = new web3.eth.Contract(multipleabi,bep20);
                            //  var restt = await newnftsingle.methods.serviceFunction(fee1.toString()).send({
                            //    from: result[0]
                            //  });
                            // var token = "["+config.tokenname+"]"
                            //  var restt = await newnftsingle.methods.addTokenType(token.toString(),config.WMATICaddress).send({
                            //    from: result[0]
                            //  });
                            var payload = {
                              useraddress: currAddr,
                              newcontract: bep20,
                              collectionname: owncollectionname,
                              collectionsymbol: owncollectionsymbol,
                              collectiondescription: collectiondescription,
                              imageUser: photo,
                              type: CollectibleType,
                              url: collectionurl.replace(
                                "http://212.71.233.123/pyramidionscollection/",
                                ""
                              ),
                            };

                            var collectionresp = await Collection_Create(
                              payload
                            );
                            if (collectionresp.data.status) {
                              setcustomcollection(bep20);
                              Set_showloadercollect(false);
                              window
                                .$("#choose_collection_modal")
                                .modal("hide");
                              GetUserCollections(currAddr, "");
                              toast.success(
                                "Collection created",
                                toasterOption
                              );
                            } else {
                              Set_showloadercollect(false);
                              toast.error("Server Error", toasterOption);
                            }
                          }
                        })
                        .catch((err) => {
                          console.log(err, "===========eeeeeeee");
                          Set_showloadercollect(false);
                          toast.error("User Rejected", toasterOption);
                        });
                    } catch (err) {
                      console.log(err, "===========eeeeeeeeerrrrrrrr");
                      Set_showloadercollect(false);
                      toast.error("User Rejected", toasterOption);
                    }
                  } else {
                    Set_showloadercollect(false);
                    toast.error("Please Choose Mainnet", toasterOption);
                  }
                } else {
                  // Set_showloadercollect(false)
                  // toast.error("Please Choose Mainnet", toasterOption);
                }
              }
            })
            .catch((e) => {});
        } else {
          setWalletConnected(false);
          setmainnet(false);
          toast.error("Please add Metamask plugin", toasterOption);
        }
      } catch (err) {
        setmainnet(false);
        setWalletConnected(false);
      }
    }
  };

  function loadScript() {
    dropdown("#item_category");
    dropdown("#price_catagory");
    dropdown("#item_category_multiple1");
    dropdown("#buy_category");
    dropdown("#item_collection");
    dropdown("#item_category_multiple1");

    function dropdown(e) {
      var obj = $(e + ".dropdown");
      var btn = obj.find(".btn-selector");
      var dd = obj.find("ul");
      var opt = dd.find("li");

      obj
        .on("click", function () {
          dd.show();
        })
        .on("mouseleave", function () {
          dd.hide();
        });

      opt.on("click", function () {
        dd.hide();
        var txt = $(this).text();
        opt.removeClass("active");
        $(this).addClass("active");
        btn.text(txt);
      });
    }
  }

  async function DateChange(from, val) {
    if (from == "StartDateDropDown") {
      if (val == "PickStartDate") {
        ModalAction("calendar_modal", "show");
      } else {
        Set_StartDate("Right after listing");
      }
    } else if (from == "EndDateDropDown") {
      if (val == "PickEndDate") {
        ModalAction("calendar_modal_expire", "show");
      } else {
        Set_EndDate(val);
        var myDate = new Date();
        var newdat = myDate.setDate(myDate.getDate() + parseInt(val));
        var newdate = new Date(newdat);
        set_EndClocktime(newdate);
      }
    }
  }

  async function ModalAction(id, type) {
    window.$("#" + id).modal(type);
    if (id == "calendar_modal") {
      if (Clocktime) {
        var dt = new Date(Clocktime);
        dt.setSeconds(0);
        var dt1 = dt.toLocaleString();
        Set_StartDate(dt1);
      }
    } else if (id == "calendar_modal_expire") {
      if (EndClocktime) {
        var dt = new Date(EndClocktime);
        dt.setSeconds(0);
        var dt1 = dt.toLocaleString();
        Set_EndDate(dt1);
      }
    }
  }

  async function GetCategoryCall() {
    var resp = await GetCategoryAction();
    if (resp && resp.data && resp.data.list) {
      var CategoryOption = [];
      resp.data.list.map((item) => {
        CategoryOption.push({
          name: "TokenCategory",
          value: item._id,
          label: item.category,
        });
      });
      setCategoryOption(CategoryOption);
    }
  }
  async function getWhitelistAdmin() {
    try {
      var web3 = new Web3(window.ethereum);
      // const getaccounts = await web3.eth.getAccounts();
      var getaccounts = window.web3.eth.defaultAccount;
      if (getaccounts != undefined) {
        var payload = {
          address: getaccounts,
        };
        setUseraddress(getaccounts);
        const resp = await getwhitelist(payload);
        if (resp && resp.data) {
          if (resp.data.data != null) {
            setWhitelistadmin(resp.data.data.address);
            if (resp.data.data.address == getaccounts) {
              var bidpriceset = [
                { value: config.currencySymbol, label: config.currencySymbol },
                { value: config.owntokenSymbol, label: config.owntokenSymbol },
              ];
              set_bidprice(bidpriceset);
            } else {
              var bidpriceset = [
                { value: config.currencySymbol, label: config.currencySymbol },
              ];
              set_bidprice(bidpriceset);
            }
          } else {
            var bidpriceset = [
              { value: config.currencySymbol, label: config.currencySymbol },
            ];
            set_bidprice(bidpriceset);
            setWhitelistadmin("");
          }
        }
        console.log("resp", resp);
      }
    } catch (err) {}
  }
  function changeCategory(eve) {
    setTokenCategory(eve.label);
    setCategoryname(eve.label);
  }

  function changeCurrency(eve) {
    console.log(eve);
    setcurrencyName(eve.value);
    setcurrency(eve.value);
  }

  async function approvestatus() {
    var currAddr = await getCurAddr();
    if (typeof currAddr != "undefined") {
      var selectedcontract =
        CollectiblesType == "Single"
          ? config.singleContract
          : config.multipleContract;

      if (contractAddress && contractAddress != "") {
        var selectedcontract = contractAddress;
      }
      let data = {
        address: currAddr,
        contractaddress: selectedcontract,
      };
      var Resp = await getapprove(data);
      console.log(Resp, "===================appstatus");
      if (
        Resp &&
        Resp.data &&
        Resp.data.data &&
        Resp.data.data.data &&
        Resp.data.data.data.contractaddress &&
        Resp.data.data.data.contractaddress == selectedcontract
      ) {
        setUserApproved(true);
        setApproveCallStatus("done");
      } else {
        setUserApproved(false);
      }
    }
  }

  async function Get_MyItemAccountAddr_Details() {
    var currAddr = await getCurAddr();
    if (typeof currAddr != "undefined") {
      let data = {
        addr: currAddr,
      };
      var Resp = await ParamAccountAddr_Detail_Get(data);
      console.log(Resp, "===========fromcreate");
      if (Resp && Resp.data && Resp.data.User && Resp.data.User.curraddress) {
        if (Resp.data.User) {
          if (
            Resp.data.User.image &&
            Resp.data.User.image != null &&
            Resp.data.User.image != undefined &&
            Resp.data.User.image != ""
          ) {
            setprofileimage(
              config.Back_URL + "profile/" + Resp.data.User.image
            );
          }
          setprofilestatus(Resp.data.User.isverified);
        }
      } else {
      }
    }
  }

  function changecollectionCategory(ev) {
    setCollectioncategory(ev.label);
    setCollectioncategoryname(ev.label);
    setcontractAddress(ev.value);
    setDefaultCollection("");
    setSelectedOption(ev);

    var bidpriceset = [
      { value: config.currencySymbol, label: config.currencySymbol },
    ];
    set_bidprice(bidpriceset);
    setcurrencyName("ETH");
  }
  const selectFileChange = (e) => {
    var validExtensions = [
      "jpg",
      "png",
      "gif",
      "webp",
      "mp4",
      "mp3",
      "jpeg",
      "svg",
      "mpeg",
      "avi",
      "mav",
    ]; //array of valid extensions
    if (e.target && e.target.files) {
      var reader = new FileReader();
      var file = e.target.files[0];
      console.log("onchange_file : ", file);
      var fileName = file.name;
      var fileNameExt = fileName.substr(fileName.lastIndexOf(".") + 1);
      if ($.inArray(fileNameExt, validExtensions) == -1) {
        toast.error(
          "Only these file types are accepted : " + validExtensions.join(", "),
          toasterOption
        );
        $("input[name='image']").val("");
        return false;
      } else {
        const fileSize = file.size / 1024 / 1024;
        if (fileSize > 100) {
          toast.error("File size exceeds 100 MB", toasterOption);
          $("input[name='image']").val("");
          return false;
        } else {
          setTokenFile(file);
          var url = reader.readAsDataURL(file);
          reader.onloadend = function (e) {
            if (reader.result) {
              console.log("reader.result", reader.result);
              setTokenFilePreReader(reader.result);
            }
          }.bind(this);
          setTokenFilePreUrl(e.target.value);
        }
      }
    }
  };
  const changePutOnSaleType = (type) => {
    setPutOnSaleType(type);
    if (type == "FixedPrice") {
      Set_MinimumBid("");
    } else if ((type = "TimedAuction")) {
      setTokenPrice("");
    } else {
      Set_MinimumBid("");
      setTokenPrice("");
    }
  };

  const changeDefaultCollection = (type) => {
    setPrice(0);
    setDefaultCollection(type);
    setCollectioncategory({ label: "" });
    setCollectioncategoryname("Select");
    setcontractAddress(
      CollectiblesType == "Single"
        ? config.defaultCollectionSingle
        : config.defaultCollectionMultiple
    );
  };

  const changeCollectiblesType = async (type) => {
    setSelectedOption(null);
    setCollectiblesType(type);
    Set_CollectibleType(type == "Single" ? 721 : 1155);
    await GetUserCollections("", type == "Single" ? 721 : 1155);

    setcontractAddress(
      type == "Single" ? config.singleContract : config.multipleContract
    );
    await changePutOnSaleType("FixedPrice");
  };

  const PriceCalculate = async (data = {}) => {
    try {
      var provider = window.ethereum;
      var web3 = new Web3(provider);
      var price = typeof data.price != "undefined" ? data.price : TokenPrice;
      var weii = await web3.utils.toWei(price.toString());
      var nftContract = new web3.eth.Contract(
        Single_ABI,
        config.singleContract
      );
      var fee = await nftContract.methods.getServiceFee().call();
      var per = (weii * fee) / 1e20;
      var mulWei = parseFloat(weii - per);
      Set_YouWillGet((mulWei / config.decimalvalues).toFixed(config.toFixed));
      setTokenWill((mulWei / config.decimalvalues).toFixed(config.toFixed));
    } catch (err) {}
  };
  const CheckedChange = (e) => {
    if (e && e.target && e.target.name) {
      if (e.target.name == "putonsale") {
        if (PutOnSale == false) {
          setputonmarket(true);
          setPutOnSale(true);
          if (PutOnSaleType == "" || PutOnSaleType == "putonmarket") {
            setPutOnSaleType("FixedPrice");
          }
        } else {
          setputonmarket(false);
          setPutOnSale(false);
        }
      } else if (e.target.name == "unlockoncepurchased") {
        if (Unlockoncepurchased == false) {
          Set_Unlockoncepurchased(true);
        } else {
          Set_Unlockoncepurchased(false);
        }
      }
    }
  };
  const inputChange = (e) => {
    if (
      e &&
      e.target &&
      typeof e.target.value != "undefined" &&
      e.target.name
    ) {
      var value = e.target.value;
      console.log("Enter Valid price", value, isNaN(value), parseFloat(value));
      switch (e.target.name) {
        case "TokenPrice":
          if (value != "" && isNaN(value) == false && value > 0) {
            setTokenPrice(value);
            PriceCalculate({ price: value });
            ValidateError.TokenPrice = "";
            setValidateError(ValidateError);
          } else {
            ValidateError.TokenPrice = "Enter Valid price";
            setValidateError(ValidateError);
            setTokenPrice("0");
            PriceCalculate({ price: 0 });
          }
          break;
        case "Price":
          if (value != "" && isNaN(value) == false) {
            setPrice(value);
            PriceCalculate({ price: value });
            ValidateError.Price = "";
            setValidateError(ValidateError);
          } else {
            ValidateError.Price = "Enter Valid price";
            setValidateError(ValidateError);
            setPrice();
            PriceCalculate({ price: 0 });
          }
          break;
        case "TokenName":
          setTokenName(value);
          break;
        case "TokenDescription":
          setTokenDescription(value);
          break;
        case "TokenRoyalities":
          setTokenRoyalities(value);
          break;
        case "TokenProperties":
          setTokenProperties(value);
          break;
        case "UnLockcontent":
          Set_UnLockcontent(value);
          break;
        case "MinimumBid":
          Set_MinimumBid(value);
          break;
        case "MaximumBid":
          Set_MaximumBid(value);
          break;
        case "TokenQuantity":
          Set_TokenQuantity(value);
          break;
        default:
      }
    }
  };

  async function CreateItemValidation(chk) {
    if (chk) {
      console.log("TokenCategory", TokenCategory);
      var ValidateError = {};

      if (PutOnSaleType == "TimedAuction" && putonmarket) {
        var currDate = new Date();
        var sDate = new Date(Clocktime);
        if (StartDate == "Right after listing") {
          set_Clocktime(currDate);
          sDate = currDate;
        }

        var startDate = new Date(Clocktime);
        var eDate = new Date(EndClocktime);
        startDate.setSeconds(0);
        eDate.setSeconds(0);
        if (new Date(currDate) > new Date(sDate)) {
          ValidateError.StartDate =
            "Start date & Time must be greater than now";
        }

        if (Date.parse(startDate) >= Date.parse(eDate)) {
          ValidateError.EndDate =
            '"End date" & Time must be greater than start date and Time';
        }
      }

      if (TokenName == "") {
        ValidateError.TokenName = '"Title" is not allowed to be empty';
      }

      if (TokenRoyalities == "") {
        ValidateError.TokenRoyalities = '"Royalty" is not allowed to be empty';
      } else if (isNaN(TokenRoyalities) == true) {
        ValidateError.TokenRoyalities = '"Royalty" must be a number';
      } else if (TokenRoyalities > 50) {
        ValidateError.TokenRoyalities =
          '"Royalty" must be less than or equal to 40';
      }

      if (TokenFilePreUrl == "") {
        ValidateError.TokenFilePreUrl = '"File" is required';
      }

      if (Unlockoncepurchased && UnLockcontent == "") {
        ValidateError.UnLockcontent = '"Locked content" is required';
      }

      if (PutOnSaleType == "FixedPrice" && putonmarket) {
        if (Price == "" || (isNaN(Price) == true && Price == 0)) {
          ValidateError.Price = '"Price" must be a number';
        } else if (Price == 0 || parseFloat(Price) < 0) {
          ValidateError.Price = '"Price" must be greater than zero';
        }
      }

      if (PutOnSaleType == "TimedAuction" && putonmarket) {
        if (MinimumBid == "" || parseFloat(MinimumBid) <= 0) {
          ValidateError.MinimumBid = '"Minimum Bid" must be a number';
        }
        if (MaximumBid == "" || parseFloat(MaximumBid) <= 0) {
          ValidateError.MaximumBid = '"Maximum Bid" must be a number';
        }
      }

      if (
        typeof TokenCategory == "undefined" ||
        TokenCategory == "" ||
        TokenCategory.label == ""
      ) {
        ValidateError.TokenCategory = '"Category" is required';
      }

      if (TokenQuantity == "" || isNaN(TokenQuantity) == true) {
        ValidateError.TokenQuantity =
          '"Number of copies" must be a number & greater than zero';
      } else if (TokenQuantity == 0) {
        ValidateError.TokenQuantity =
          '"Number of copies" must be greater than zero';
      }

      if (
        Unlockoncepurchased == true &&
        UnLockcontent != null &&
        UnLockcontent != undefined &&
        UnLockcontent != ""
      ) {
      } else if (Unlockoncepurchased == true) {
        ValidateError.UnLockcontent = "Unlock content must be a Valid one";
      }
      setValidateError(ValidateError);
      return ValidateError;
    } else {
      return {};
    }
  }

  async function CreateItem() {
    Set_FormSubmitUserClicked(true);
    var connectwallet = localStorage.getItem("epochMetamask");
    if (!connectwallet) {
      toast.error("Please connect to a Metamask wallet", toasterOption);
      return false;
    }
    var errors = await CreateItemValidation(true);
    console.log("Form validation error", errors);
    var errorsSize = Object.keys(errors).length;

    if (errorsSize != 0) {
      toast.error(
        "Form validation error, please fill all the required fields",
        toasterOption
      );
      return false;
    } else if (window.ethereum) {
      await approvestatus();
      if (
        typeof window.web3 == "undefined" ||
        typeof window.web3.eth == "undefined"
      ) {
        toast.error("Please Connect to Binance Network", toasterOption);
        return false;
      } else {
        var currAddr = window.web3.eth.defaultAccount;
        window.web3.eth.getBalance(currAddr, async (errors, balance) => {
          var usercurbal = 0;
          if (typeof balance == "undefined" || balance == null) {
            Set_UserAccountBal(0);
          } else {
            usercurbal = balance / config.decimalvalues;
            Set_UserAccountBal(usercurbal);
          }
          if (usercurbal == 0) {
            toast.error("Insufficient balance", toasterOption);
            return false;
          }
          var TokenCategory_label = TokenCategory;

          let payload = {
            TokenName,
            TokenRoyalities,
            image: TokenFile,
            TokenCategory_label,
            PutOnSaleType,
            TokenPrice,
          };
          window.$("#create_item_modal").modal("show");

          // console.log("createTokenval payload:", payload)
          // const resp = await CreateTokenValidationAction(payload);
          // console.log('resp', resp);
          // if(resp && resp.data) {
          //   if(resp.data.errors) {
          //     var errors = resp.data.errors;
          //     var errorsSize = Object.keys(errors).length;
          //     if(errorsSize != 0) {
          //       setValidateError(errors);
          //       toast.error("Form validation error. Fix all mistakes and submit again", toasterOption);
          //     }
          //     else {
          //       setValidateError({});
          //       window.$('#create_item_modal').modal('show');
          //     }
          //   }
          // }
        });
      }
    }
  }
  async function ApproveCall() {
    console.log("MinimumBid", MinimumBid);
    if (!window.ethereum) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
      return false;
    }

    var web3 = new Web3(window.ethereum);
    var currAddr = window.web3.eth.defaultAccount;
    if (!currAddr) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
      return false;
    }

    var singleContract = new web3.eth.Contract(
      Single_ABI,
      config.singleContract
    );

    var multipleContract = new web3.eth.Contract(
      Multiple_ABI,
      config.multipleContract
    );

    var selectedcontract =
      CollectiblesType == "Single"
        ? config.singleContract
        : config.multipleContract;

    if (contractAddress && contractAddress != "") {
      if (CollectiblesType == "Single") {
        var CoursetroContract = new web3.eth.Contract(
          Single_ABI,
          contractAddress
        );
      } else {
        var CoursetroContract = new web3.eth.Contract(
          Multiple_ABI,
          contractAddress
        );
      }
      var selectedcontract = contractAddress;
    } else {
      var CoursetroContract =
        CollectiblesType == "Single" ? singleContract : multipleContract;
    }

    setApproveCallStatus("processing");

    if (userApproved == false) {
      console.log(selectedcontract,"=======selectedcontractselectedcontract")
      await CoursetroContract.methods
        .setApproval(selectedcontract, true)
        .send({
          from: currAddr,
        })
        .then(async (result) => {
          var datass = {
            address: currAddr,
            contractaddress: selectedcontract,
          };
          var restu = await addapprove(datass);
        })
        .catch((error) => {
          toast.error("Wallet authorization failed", toasterOption);
          setApproveCallStatus("tryagain");
        });
    }
    var unix = Math.round(+new Date() / 1000);
    let ran = Math.floor(Math.random() * 100 + 1);
    let tokenid = unix + ran;

    Set_TokenCount(tokenid);
    var senddata = {
      Image: TokenFile,
      tokenid: tokenid,
      TokenName: TokenName,
    };
    console.log("@@@@@@@@", senddata);
    var ipfsimghashget = await ipfsImageHashGet(senddata);
    console.log(ipfsimghashget,"=======ipfsimagehash")
    if (ipfsimghashget.data !== undefined) {
      if (ipfsimghashget.data.ipfsval != "") {
        setIpfsHash(ipfsimghashget.data.ipfsval);
        setipfshashurl(`${config.IPFS_IMG}/${ipfsimghashget.data.ipfsval}`);
      }
      var newobj = {
        name: TokenName,
        tokenId: tokenid,
        image: config.IPFS_IMG + "/" + ipfsimghashget.data.ipfsval,
      };
      console.log("newobj", newobj);

      var ipfsmetatagVal = await ipfsmetadatafunciton(newobj);
      console.log(ipfsmetatagVal,"===========ipfsmetatagVal")
      if (ipfsmetatagVal.data !== undefined) {
        if (ipfsmetatagVal.data.ipfsval != "") {
          var ipfsurl = ipfsmetatagVal.data.ipfsval;
          set_ipfsmetatag(`${config.IPFS_IMG}/${ipfsurl}`);
        }
      }
    }

    toast.success("Wallet authorized", toasterOption);
    setApproveCallStatus("done");
  }

  async function againapprovecall() {
    var unix = Math.round(+new Date() / 1000);
    let ran = Math.floor(Math.random() * 100 + 1);
    let tokenid = unix + ran;

    Set_TokenCount(tokenid);

    return tokenid;
  }

  async function MintCall() {
    let ipfs_hash = ipfshash;
    let ipfs_url = ipfsmetatag;
    if (!window.ethereum) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
      return false;
    }
    var web3 = new Web3(window.ethereum);
    var currAddr = window.web3.eth.defaultAccount;
    var CurrAddr = window.web3.eth.defaultAccount;
    if (!currAddr) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
      return false;
    }

    setMintCallStatus("processing");
    var tokeid = "";
    if (userApproved == true) {
      tokeid = await againapprovecall();
      Set_TokenCount(tokeid);
      var senddata = {
        Image: TokenFile,
        tokenid: tokeid,
        TokenName: TokenName,
      };
      console.log("@@@@@@@@", senddata);
      var ipfsimghashget = await ipfsImageHashGet(senddata);
      if (ipfsimghashget.data !== undefined) {
        if (ipfsimghashget.data.ipfsval != "") {
          setIpfsHash(ipfsimghashget.data.ipfsval);
          ipfs_hash = ipfsimghashget.data.ipfsval;
          setipfshashurl(`${config.IPFS_IMG}/${ipfsimghashget.data.ipfsval}`);
        }
        var newobj = {
          name: TokenName,
          tokenId: tokeid,
          image: config.IPFS_IMG + "/" + ipfsimghashget.data.ipfsval,
        };
        console.log("newobj", newobj);

        var ipfsmetatagVal = await ipfsmetadatafunciton(newobj);

        if (ipfsmetatagVal.data !== undefined) {
          if (ipfsmetatagVal.data.ipfsval != "") {
            var ipfsurl = ipfsmetatagVal.data.ipfsval;
            set_ipfsmetatag(`${config.IPFS_IMG}/${ipfsurl}`);
            ipfs_url = config.IPFS_IMG + "/" + ipfsurl;
          }
        }
      }
    } else {
      tokeid = TokenCount;
    }
    console.log(tokeid, "=======toketoke");
    var singleContract = new web3.eth.Contract(
      Single_ABI,
      config.singleContract
    );
    var multipleContract = new web3.eth.Contract(
      Multiple_ABI,
      config.multipleContract
    );
    var selectedcontract =
      CollectiblesType == "Single"
        ? config.singleContract
        : config.multipleContract;
    if (contractAddress && contractAddress != "") {
      if (CollectiblesType == "Single") {
        var CoursetroContract = new web3.eth.Contract(
          Single_ABI,
          contractAddress
        );
      } else {
        var CoursetroContract = new web3.eth.Contract(
          Multiple_ABI,
          contractAddress
        );
      }
      var selectedcontract = contractAddress;
    } else {
      var CoursetroContract =
        CollectiblesType == "Single" ? singleContract : multipleContract;
    }

    const Digits = config.decimalvalues;
    const TokenPriceInStr = (Price * Digits).toString();

    if (CollectiblesType == "Single") {
      console.log(tokeid,
          TokenName,
          ipfs_url,
          ipfs_hash,
          TokenPriceInStr,
          TokenQuantity,
          TokenRoyalities,
          "singlesaran");

      await CoursetroContract.methods
        .mint(
          tokeid,
          ipfs_url,
          TokenPriceInStr,
          TokenQuantity,
          TokenRoyalities
        )
        .send({ from: CurrAddr })
        .then(async (result) => {
          var transactionHash = "";
          if (result.transactionHash) {
            transactionHash = result.transactionHash;
          } else {
            transactionHash = result;
          }
          Set_MintHashVal(transactionHash);
          // setTimeout(() => {
          toast.success("NFT minted successfully", toasterOption);
          var Status = "true";
          var TokenAddItemPayload = {
            Image: TokenFile,
            ipfsimage: ipfs_hash,
            Name: TokenName,
            Count: tokeid,
            Description: TokenDescription,
            Price: Price,
            TokenPrice: TokenPrice,
            Royalities: TokenRoyalities,
            Category_label: TokenCategory,
            Properties: TokenProperties,
            Owner: CurrAddr,
            Creator: CurrAddr,
            CategoryId: TokenCategory,
            Quantity: TokenQuantity,
            Balance: TokenQuantity,
            ContractAddress: selectedcontract,
            Status: Status,
            HashValue: transactionHash,
            Type: 721,
            MinimumBid: 0,
            MaximumBid: 0,
            Clocktime: "",
            EndClocktime: "",
            UnLockcontent: "",
            PutOnSale: PutOnSale,
            PutOnSaleType: PutOnSaleType,
            currencyName: currencyName,
          };
          console.log(
            TokenAddItemPayload,
            "=================================infront"
          );
          if (Unlockoncepurchased == true) {
            TokenAddItemPayload.UnLockcontent = UnLockcontent;
          }

          // if(PutOnSale==true) {

          if (!putonmarket) {
            TokenAddItemPayload.Price = 0;
            TokenAddItemPayload.TokenPrice = 0;
            TokenAddItemPayload.MinimumBid = 0;
            TokenAddItemPayload.MaximumBid = 0;
            TokenAddItemPayload.Clocktime = Clocktime;
            TokenAddItemPayload.EndClocktime = EndClocktime;
            TokenAddItemPayload.PutOnSale = false;
            TokenAddItemPayload.PutOnSaleType = "putonmarket";
          } else if (PutOnSaleType == "FixedPrice") {
            TokenAddItemPayload.Price = Price;
            TokenAddItemPayload.TokenPrice = TokenPrice;
          } else if (PutOnSaleType == "TimedAuction") {
            TokenAddItemPayload.MinimumBid = MinimumBid;
            TokenAddItemPayload.MaximumBid = MaximumBid;
            TokenAddItemPayload.Clocktime = Clocktime;
            TokenAddItemPayload.EndClocktime = EndClocktime;
            TokenAddItemPayload.Price = 0;
          } else {
            TokenAddItemPayload.PutOnSaleType = PutOnSaleType;
            TokenAddItemPayload.MinimumBid = MinimumBid;
            TokenAddItemPayload.MaximumBid = MaximumBid;
          }
          // }

          await TokenAddItemAction(TokenAddItemPayload);
          var TokenAddOwnerPayload = {
            Count: tokeid,
            Price: Price,
            TokenPrice: TokenPrice,
            Owner: CurrAddr,
            Balance: TokenQuantity,
            Quantity: TokenQuantity,
            ContractAddress: selectedcontract,
            Type: 721,
            HashValue: transactionHash,
            Status: Status,
            currencyName: currencyName,
          };
          if (!putonmarket) {
            TokenAddOwnerPayload.Price = 0;
            TokenAddOwnerPayload.TokenPrice = 0;
            TokenAddItemPayload.MinimumBid = 0;
            TokenAddItemPayload.MaximumBid = 0;
          } else if (PutOnSaleType == "FixedPrice") {
            TokenAddOwnerPayload.Price = Price;
            TokenAddOwnerPayload.TokenPrice = TokenPrice;
          } else if (PutOnSaleType == "TimedAuction") {
            TokenAddItemPayload.MinimumBid = MinimumBid;
            TokenAddItemPayload.MaximumBid = MaximumBid;
          }
          await TokenAddOwnerAction(TokenAddOwnerPayload);
          setMintCallStatus("done");
          if (!putonmarket) {
            setTimeout(() => window.$("#create_item_modal").modal("hide"), 600);
            setTimeout(() => (window.location.href = "/pyramidions"), 1200);
          }
          // })
          // }, 1500);
        })
        .catch((error) => {
          toast.error("Mint action rejected by user", toasterOption);
          setMintCallStatus("tryagain");
        });
    } else {
      var currAddr = window.web3.eth.defaultAccount;

      console.log( tokeid,
          TokenPriceInStr,
          TokenRoyalities,
          TokenQuantity,
          TokenName,
          ipfs_hash,
          ipfs_url,"saranMultiple");
      await CoursetroContract.methods
        .mint(
          tokeid,
          TokenPriceInStr,
          TokenRoyalities,
          TokenQuantity,
          ipfs_url
        )
        .send({ from: currAddr })
        .then(async (result) => {
          var transactionHash = "";
          if (result.transactionHash) {
            transactionHash = result.transactionHash;
          } else {
            transactionHash = result;
          }
          Set_MintHashVal(transactionHash);
          toast.success("NFT minted successfully", toasterOption);
          var Status = "true";
          var TokenAddItemPayload = {
            Image: TokenFile,
            ipfsimage: ipfs_hash,
            Name: TokenName,
            Count: tokeid,
            Description: TokenDescription,
            Price: Price,
            TokenPrice: TokenPrice,
            Royalities: TokenRoyalities,
            Category_label: TokenCategory,
            Properties: TokenProperties,
            Owner: CurrAddr,
            Creator: CurrAddr,
            CategoryId: TokenCategory,
            Quantity: TokenQuantity,
            Balance: TokenQuantity,
            ContractAddress: selectedcontract,
            Status: Status,
            HashValue: transactionHash,
            Type: 1155,
            MinimumBid: 0,
            Clocktime: "",
            EndClocktime: "",
            UnLockcontent: "",
            PutOnSale: PutOnSale,
            PutOnSaleType: PutOnSaleType,
            currencyName: currencyName,
          };
          if (Unlockoncepurchased == true) {
            TokenAddItemPayload.UnLockcontent = UnLockcontent;
          }
          if (collectioncategoryname != "Select") {
            TokenAddItemPayload.collectioncategoryname = collectioncategoryname;
          }
          if (!putonmarket) {
            TokenAddItemPayload.Price = 0;
            TokenAddItemPayload.TokenPrice = 0;
            TokenAddItemPayload.MinimumBid = 0;
            TokenAddItemPayload.MaximumBid = 0;
            TokenAddItemPayload.Clocktime = Clocktime;
            TokenAddItemPayload.EndClocktime = EndClocktime;
            TokenAddItemPayload.PutOnSale = false;
            TokenAddItemPayload.PutOnSaleType = "putonmarket";
          } else if (PutOnSale == true) {
            if (PutOnSaleType == "FixedPrice") {
              TokenAddItemPayload.Price = Price;
              TokenAddItemPayload.TokenPrice = TokenPrice;
            } else if (PutOnSaleType == "TimedAuction") {
              TokenAddItemPayload.MinimumBid = MinimumBid;
              TokenAddItemPayload.MaximumBid = MaximumBid;
              TokenAddItemPayload.Clocktime = Clocktime;
              TokenAddItemPayload.EndClocktime = EndClocktime;
              TokenAddItemPayload.Price = 0;
            } else {
              TokenAddItemPayload.MinimumBid = MinimumBid;
              TokenAddItemPayload.MaximumBid = MaximumBid;
            }
          }
          await TokenAddItemAction(TokenAddItemPayload);
          var TokenAddOwnerPayload = {
            Count: tokeid,
            Price: Price,
            TokenPrice: TokenPrice,
            Owner: CurrAddr,
            Balance: TokenQuantity,
            Quantity: TokenQuantity,
            ContractAddress: selectedcontract,
            Type: 1155,
            HashValue: transactionHash,
            Status: Status,
            currencyName: currencyName,
          };
          if (!putonmarket) {
            TokenAddOwnerPayload.Price = 0;
            TokenAddOwnerPayload.TokenPrice = 0;
            TokenAddItemPayload.MinimumBid = 0;
            TokenAddItemPayload.MaximumBid = 0;
          } else if (PutOnSaleType == "FixedPrice") {
            TokenAddOwnerPayload.Price = Price;
            TokenAddOwnerPayload.TokenPrice = TokenPrice;
          }

          await TokenAddOwnerAction(TokenAddOwnerPayload);
          setMintCallStatus("done");
          if (!putonmarket) {
            setTimeout(() => window.$("#create_item_modal").modal("hide"), 600);
            setTimeout(() => (window.location.href = "/pyramidions"), 1200);
          }
          // })
          // }, 1500);
        })
        .catch((error) => {
          toast.error("Action rejected by user", toasterOption);
          setMintCallStatus("tryagain");
        });
    }
  }
  async function SignCall() {
    if (!window.ethereum) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
    }
    var web3 = new Web3(window.ethereum);
    var currAddr = window.web3.eth.defaultAccount;
    if (!currAddr) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
    }

    setSignCallStatus("processing");
    web3.eth.personal
      .sign("Sign the sale order to put NFT for Sale", currAddr)
      .then(async (result) => {
        toast.success("Signed succefully", toasterOption);
        setSignCallStatus("done");
        if (!Unlockoncepurchased) {
          setTimeout(() => window.$("#create_item_modal").modal("hide"), 600);
          setTimeout(() => (window.location.href = "/pyramidions"), 1200);
        }
      })
      .catch(() => {
        toast.error("Signature rejected by user", toasterOption);
        setSignCallStatus("tryagain");
      });
  }

  async function AfterWalletConnected() {
    // GetCategoryCall();
  }

  async function SignLockCall() {
    if (!window.ethereum) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
    }
    var web3 = new Web3(window.ethereum);
    var currAddr = window.web3.eth.defaultAccount;
    if (!currAddr) {
      toast.warning("OOPS!..connect Your Wallet", toasterOption);
    }

    setSignLockCallStatus("processing");
    web3.eth.personal
      .sign("Sign and authorize the unlockable contents", currAddr)
      .then(async (result) => {
        toast.success("Signed succefully", toasterOption);
        setSignLockCallStatus("done");
        setTimeout(() => window.$("#create_item_modal").modal("hide"), 600);
        setTimeout(() => (window.location.href = "/pyramidions"), 1200);
      })
      .catch(() => {
        toast.error("Signature rejected by user", toasterOption);
        setSignLockCallStatus("tryagain");
      });
  }
  // Countdown Timer
  const currentDate = new Date();
  const year =
    currentDate.getMonth() === 11 && currentDate.getDate() > 23
      ? currentDate.getFullYear() + 1
      : currentDate.getFullYear();

  const renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <div className="timer_panel">
        <span>
          <span className="timer_time">{zeroPad(days)}</span>
          <span className="timer_label">d</span>
        </span>
        <span className="timer_dots"> </span>
        <span>
          <span className="timer_time">{zeroPad(hours)}</span>
          <span className="timer_label">h</span>
        </span>
        <span className="timer_dots"> </span>
        <span>
          <span className="timer_time">{zeroPad(minutes)}</span>
          <span className="timer_label">m</span>
        </span>
        <span className="timer_dots"> </span>
        <span>
          <span className="timer_time">{zeroPad(seconds)}</span>
          <span className="timer_label">s</span>
        </span>
      </div>
    );
  };

  var settings = {
    center: false,
    items: 5,
    loop: true,
    margin: 15,
    nav: true,
    navText: [
      "<i class='fa fa-chevron-left'></i>",
      "<i class='fa fa-chevron-right'></i>",
    ],
    dots: false,
    responsive: {
      1000: {
        items: 3,
      },
      600: {
        items: 2,
      },
      0: {
        items: 2,
      },
    },
  };
  return (
    <div id="wrapper">
      <ScrollToTopOnMount />
      <ConnectWallet
        Set_UserAccountAddr={Set_UserAccountAddr}
        Set_UserAccountBal={Set_UserAccountBal}
        Set_WalletConnected={setWalletConnected}
        Set_AddressUserDetails={Set_AddressUserDetails}
        AddressUserDetails={AddressUserDetails}
        Set_Accounts={Set_Accounts}
        WalletConnected={WalletConnected}
        AfterWalletConnected={AfterWalletConnected}
      />
      <Header />
      <div className="no-bottom no-top" id="content">
        <section
          id="subheader"
          class="text-light"
          data-bgimage="url(images/background/subheader-dark.jpg) top"
        >
          <div class="center-y relative text-center">
            <div class="container">
              <div class="row">
                <div class="col-md-12 text-center">
                  <h1>Create</h1>
                </div>
                <div class="clearfix"></div>
              </div>
            </div>
          </div>
        </section>

        <section aria-label="section" className="pt30 pb30">
          <div class="container">
            <div class="row wow fadeIn">
              <div class="col-lg-7 offset-lg-1">
                <div className="de_tab tab_simple">
                  <nav>
                    <div
                      className="nav nav-tabs de_nav justify-content-center"
                      id="nav-tab"
                      role="tablist"
                    >
                      <a
                        onClick={() => changeCollectiblesType("Single")}
                        className={
                          CollectiblesType == "Single"
                            ? "nav-item nav-link active"
                            : "nav-item nav-link"
                        }
                        id="nav-onSale-tab"
                        data-toggle="tab"
                        href="#nav-onSale"
                        role="tab"
                        aria-controls="nav-onSale"
                        aria-selected={
                          CollectiblesType == "Single" ? "true" : "false"
                        }
                      >
                        Single
                      </a>
                      <a
                        onClick={() => changeCollectiblesType("Multiple")}
                        className={
                          CollectiblesType == "Multiple"
                            ? "nav-item nav-link active"
                            : "nav-item nav-link"
                        }
                        id="nav-onSale-tab"
                        data-toggle="tab"
                        href="#nav-onSale"
                        role="tab"
                        aria-controls="nav-onSale"
                        aria-selected={
                          CollectiblesType == "Multiple" ? "true" : "false"
                        }
                      >
                        Multiple
                      </a>
                    </div>
                  </nav>
                  <div
                    className="tab-content de_tab_content"
                    id="nav-tabContent"
                  >
                    <div
                      className="tab-pane fade show active"
                      id="nav-onSale"
                      role="tabpanel"
                      aria-labelledby="nav-onSale-tab"
                    >
                      <form
                        id="form-create-item"
                        class="form-border"
                        method="post"
                      >
                        <div class="field-set">
                          <label className="primary_label">Upload file</label>

                          <div class="d-create-file">
                            <p id="file_name">
                              PNG, JPG, JPEG, SVG, GIF, WEBP, MP4, MPEG, AVI ,
                              WAV, MP3 . Max 100 MB.
                            </p>
                            {ValidateError.TokenFilePreUrl && (
                              <span className="text-danger">
                                {ValidateError.TokenFilePreUrl}
                              </span>
                            )}

                            <div className="uploadCustomFile">
                              <input
                                type="button"
                                id="get_file"
                                class="btn-main"
                                value="Browse"
                              />
                              <input
                                type="file"
                                id="upload_file"
                                onChange={selectFileChange}
                              />
                            </div>
                          </div>

                          <div class="spacer-single"></div>

                          <label className="primary_label">
                            Create collection
                          </label>

                          <div class="de_tab tab_methods createTypeTab">
                            <nav className="mb-4">
                              <div
                                class="nav nav-tabs de_nav createNavTab"
                                id="nav-tab"
                                role="tablist"
                              >
                                <a
                                  class="nav-item nav-link"
                                  data-toggle="modal"
                                  data-target="#choose_collection_modal"
                                >
                                  <span>
                                    <i class="fas fa-plus"></i>Create
                                  </span>
                                </a>

                                {/* <a
                                  onClick={() => {
                                    changeDefaultCollection(
                                      "defaultCollection"
                                    );
                                  }}
                                  class={
                                    "nav-item nav-link " +
                                    (DefaultCollection == "defaultCollection"
                                      ? "active"
                                      : "")
                                  }
                                  id="nav-TimedAuction-tab"
                                  data-toggle="tab"
                                  href="#nav-timedAuction"
                                  role="tab"
                                  aria-controls="nav-timedAuction"
                                  aria-selected={
                                    PutOnSaleType == "TimedAuction"
                                      ? "true"
                                      : "false"
                                  }
                                >
                                  <span>
                                    <i class="fa fa-hourglass-1"></i>Community
                                    Collection
                                  </span>
                                </a> */}
                              </div>
                            </nav>

                            <label className="primary_label">
                              Choose collection
                            </label>

                            <Select
                              id="collection"
                              value={selectedOption}
                              onChange={changecollectionCategory}
                              options={collectionlist}
                              styles={colourStyles}
                            />
                            {ValidateError.TokenCategory && (
                              <span className="text-danger">
                                <br />
                                {ValidateError.TokenCategory}
                              </span>
                            )}
                          </div>

                          <div className="input_Unlock_section">
                            <div>
                              <label className="primary_label">
                                Put on marketplace
                              </label>
                              <p>
                                Put your new NFT on pyramidions's marketplace
                              </p>
                            </div>
                            <label className="switch1 toggle_custom">
                              <input
                                type="checkbox"
                                id="putonsale"
                                name="putonsale"
                                onChange={CheckedChange}
                                checked={putonmarket}
                              />
                              <span className="slider"></span>
                            </label>
                          </div>

                          <div class="spacer-single"></div>

                          {putonmarket && (
                            <label className="primary_label">
                              Select method
                            </label>
                          )}
                          <div class="de_tab tab_methods createTypeTab">
                            {putonmarket && (
                              <nav className="mb-4">
                                <div
                                  class="nav nav-tabs de_nav createNavTab"
                                  id="nav-tab"
                                  role="tablist"
                                >
                                  <a
                                    onClick={() => {
                                      changePutOnSaleType("FixedPrice");
                                    }}
                                    class={
                                      "nav-item nav-link " +
                                      (PutOnSaleType == "FixedPrice"
                                        ? "active"
                                        : "")
                                    }
                                    id="nav-FixedPrice-tab"
                                    data-toggle="tab"
                                    href="#nav-fixedPrice"
                                    role="tab"
                                    aria-controls="nav-fixedPrice"
                                    aria-selected={
                                      PutOnSaleType == "FixedPrice"
                                        ? "true"
                                        : "false"
                                    }
                                  >
                                    <span>
                                      <i class="fa fa-tag"></i>Fixed price
                                    </span>
                                  </a>
                                  {CollectiblesType == "Single" && (
                                    <a
                                      onClick={() => {
                                        changePutOnSaleType("TimedAuction");
                                      }}
                                      class={
                                        "nav-item nav-link " +
                                        (PutOnSaleType == "TimedAuction"
                                          ? "active"
                                          : "")
                                      }
                                      id="nav-TimedAuction-tab"
                                      data-toggle="tab"
                                      href="#nav-timedAuction"
                                      role="tab"
                                      aria-controls="nav-timedAuction"
                                      aria-selected={
                                        PutOnSaleType == "TimedAuction"
                                          ? "true"
                                          : "false"
                                      }
                                    >
                                      <span>
                                        <i class="fa fa-hourglass-1"></i>Timed
                                        auction
                                      </span>
                                    </a>
                                  )}
                                  <a
                                    onClick={() => {
                                      changePutOnSaleType("UnLimitedAuction");
                                    }}
                                    class={
                                      "nav-item nav-link " +
                                      (PutOnSaleType == "UnLimitedAuction"
                                        ? "active"
                                        : "")
                                    }
                                    id="nav-openForBids-tab"
                                    data-toggle="tab"
                                    href="#nav-openForBids"
                                    role="tab"
                                    aria-controls="nav-openForBids"
                                    aria-selected={
                                      PutOnSaleType == "UnLimitedAuction"
                                        ? "true"
                                        : "false"
                                    }
                                  >
                                    <span>
                                      <i class="fa fa-users"></i>Open for bids
                                    </span>
                                  </a>
                                </div>
                              </nav>
                            )}
                            {putonmarket && (
                              <div class="tab-content" id="nav-tabContent">
                                {PutOnSaleType == "FixedPrice" && (
                                  <div>
                                    <div
                                      class={"tab-pane fade" + "show active"}
                                      id="nav-fixedPrice"
                                      role="tabpanel"
                                      aria-labelledby="nav-home-tab"
                                    >
                                      <div id="tab_opt_1">
                                        <label className="primary_label">
                                          Price
                                        </label>
                                        <div className="select_in_but">
                                          <input
                                            type="number"
                                            id="Price"
                                            name="Price"
                                            onChange={inputChange}
                                            class="form-control mb-0 bor-0"
                                            placeholder="Enter price for one item"
                                            value={Price}
                                          />
                                          <div>
                                            <div
                                              id="item_category_multiple1"
                                              class="dropdown w-100"
                                            >
                                              <Select
                                                id="collection"
                                                onChange={changeCurrency}
                                                options={bidprice}
                                                styles={colourStyles}
                                                defaultValue={{
                                                  value: config.currencySymbol,
                                                  label: config.currencySymbol,
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      {ValidateError.Price && (
                                        <span className="text-danger">
                                          {ValidateError.Price}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                )}
                                {PutOnSaleType == "TimedAuction" && (
                                  <div
                                    class={
                                      "tab-pane fade" +
                                      (PutOnSaleType == "TimedAuction"
                                        ? " show active"
                                        : "")
                                    }
                                    id="nav-timedAuction"
                                    role="tabpanel"
                                    aria-labelledby="nav-profile-tab"
                                  >
                                    <div id="tab_opt_2">
                                      <label className="primary_label">
                                        Minimum bid amount
                                      </label>
                                      <input
                                        type="number"
                                        onKeyDown={(evt) =>
                                          ["e", "E", "+", "-", ","].includes(
                                            evt.key
                                          ) && evt.preventDefault()
                                        }
                                        name="MinimumBid"
                                        id="MinimumBid"
                                        autoComplete="off"
                                        onChange={inputChange}
                                        class="form-control"
                                        placeholder="Enter minimum bid amount"
                                      />
                                      {ValidateError.MinimumBid && (
                                        <span className="text-danger">
                                          <br />
                                          {ValidateError.MinimumBid}
                                        </span>
                                      )}

                                      <label className="primary_label">
                                        Maximum bid amount
                                      </label>
                                      <input
                                        type="number"
                                        onKeyDown={(evt) =>
                                          ["e", "E", "+", "-", ","].includes(
                                            evt.key
                                          ) && evt.preventDefault()
                                        }
                                        name="MaximumBid"
                                        id="MaximumBid"
                                        autoComplete="off"
                                        onChange={inputChange}
                                        class="form-control"
                                        placeholder="Enter maximum bid amount"
                                      />
                                      {ValidateError.MaximumBid && (
                                        <span className="text-danger">
                                          <br />
                                          {ValidateError.MaximumBid}
                                        </span>
                                      )}

                                      <div class="spacer-10"></div>

                                      <div class="row">
                                        <div class="col-md-6">
                                          <div className="drobdown_section">
                                            <label className="primary_label">
                                              Starting date
                                            </label>
                                            <div class="dropdown">
                                              <button
                                                class="btn btn-secondary dropdown-toggle filter_btn inp_btn m-0 text-left w-100"
                                                type="button"
                                                id="dropdownMenuButton"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                              >
                                                <span id="menuBut">
                                                  {StartDate}
                                                </span>
                                              </button>
                                              <div
                                                class="dropdown-menu filter_menu"
                                                aria-labelledby="dropdownMenuButton"
                                              >
                                                <div
                                                  id="RightAfterListing"
                                                  onClick={() => {
                                                    DateChange(
                                                      "StartDateDropDown",
                                                      "RightAfterListing"
                                                    );
                                                  }}
                                                >
                                                  Right after listing
                                                </div>
                                                <div
                                                  id="PickStart"
                                                  onClick={() => {
                                                    DateChange(
                                                      "StartDateDropDown",
                                                      "PickStartDate"
                                                    );
                                                  }}
                                                >
                                                  Pick specific date
                                                </div>
                                              </div>
                                              {ValidateError.StartDate && (
                                                <span className="text-danger">
                                                  {ValidateError.StartDate}
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                          {/* <input type="date" name="bid_starting_date" id="bid_starting_date" class="form-control" onChange={(date:Date) => setStartDate(date)} min="1997-01-01" /> */}
                                        </div>

                                        <div class="col-md-6">
                                          <div className="drobdown_section">
                                            <label className="primary_label">
                                              Expiration date
                                            </label>
                                            <div class="dropdown">
                                              <button
                                                class="btn btn-secondary dropdown-toggle filter_btn inp_btn m-0 text-left w-100"
                                                type="button"
                                                id="dropdownMenuButton"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                              >
                                                <span id="menuBut">
                                                  {EndDate}
                                                </span>
                                              </button>
                                              <div
                                                class="dropdown-menu filter_menu"
                                                aria-labelledby="dropdownMenuButton"
                                              >
                                                <div
                                                  onClick={() => {
                                                    DateChange(
                                                      "EndDateDropDown",
                                                      "1 Day"
                                                    );
                                                  }}
                                                >
                                                  1 Day
                                                </div>
                                                <div
                                                  onClick={() => {
                                                    DateChange(
                                                      "EndDateDropDown",
                                                      "3 Day"
                                                    );
                                                  }}
                                                >
                                                  3 Day
                                                </div>
                                                <div
                                                  onClick={() => {
                                                    DateChange(
                                                      "EndDateDropDown",
                                                      "5 Day"
                                                    );
                                                  }}
                                                >
                                                  5 Day
                                                </div>
                                                <div
                                                  onClick={() => {
                                                    DateChange(
                                                      "EndDateDropDown",
                                                      "7 Day"
                                                    );
                                                  }}
                                                >
                                                  7 Day
                                                </div>
                                                <div
                                                  onClick={() => {
                                                    DateChange(
                                                      "EndDateDropDown",
                                                      "PickEndDate"
                                                    );
                                                  }}
                                                >
                                                  Pick specific date
                                                </div>
                                              </div>
                                              {ValidateError.EndDate && (
                                                <span className="text-danger">
                                                  {ValidateError.EndDate}
                                                </span>
                                              )}
                                            </div>
                                          </div>

                                          {/* <input type="date" name="bid_expiration_date" id="bid_expiration_date" class="form-control" /> */}
                                        </div>

                                        <div class="spacer-single"></div>
                                      </div>
                                    </div>
                                  </div>
                                )}
                                {/* {PutOnSaleType == "UnLimitedAuction" && (
                                  <div
                                    class={
                                      "tab-pane fade" +
                                      (PutOnSaleType == "UnLimitedAuction"
                                        ? " show active"
                                        : "")
                                    }
                                    id="nav-openForBids"
                                    role="tabpanel"
                                    aria-labelledby="nav-contact-tab"
                                  >
                                    <div id="tab_opt_2">
                                      <label className="primary_label">
                                        Minimum bid amount
                                      </label>
                                      <input
                                        type="number"
                                        onKeyDown={(evt) =>
                                          ["e", "E", "+", "-", ","].includes(
                                            evt.key
                                          ) && evt.preventDefault()
                                        }
                                        name="MinimumBid"
                                        id="MinimumBid"
                                        autoComplete="off"
                                        onChange={inputChange}
                                        class="form-control"
                                        placeholder="Enter minimum bid amount"
                                      />
                                      {ValidateError.MinimumBid && (
                                        <span className="text-danger">
                                          <br />
                                          {ValidateError.MinimumBid}
                                        </span>
                                      )}

                                      <label className="primary_label">
                                        Maximum bid amount
                                      </label>
                                      <input
                                        type="number"
                                        onKeyDown={(evt) =>
                                          ["e", "E", "+", "-", ","].includes(
                                            evt.key
                                          ) && evt.preventDefault()
                                        }
                                        name="MaximumBid"
                                        id="MaximumBid"
                                        autoComplete="off"
                                        onChange={inputChange}
                                        class="form-control"
                                        placeholder="Enter maximum bid amount"
                                      />
                                      {ValidateError.MaximumBid && (
                                        <span className="text-danger">
                                          <br />
                                          {ValidateError.MaximumBid}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                )} */}
                              </div>
                            )}
                            <label className="primary_label">Title</label>
                            <input
                              type="text"
                              name="TokenName"
                              id="TokenName"
                              onChange={inputChange}
                              autoComplete="off"
                              class="form-control"
                              placeholder="Name your NFT"
                            />
                            {ValidateError.TokenName && (
                              <span className="text-danger">
                                {ValidateError.TokenName}
                              </span>
                            )}
                            <label className="primary_label">Description</label>
                            <textarea
                              data-autoresize
                              name="TokenDescription"
                              id="TokenDescription"
                              autoComplete="off"
                              onChange={inputChange}
                              class="form-control"
                              placeholder="Write some fascinating story about your NFT"
                              rows="2"
                            ></textarea>
                            {ValidateError.TokenDescription && (
                              <span className="text-danger">
                                {ValidateError.TokenDescription}
                              </span>
                            )}
                            <label className="primary_label">Royalty</label>
                            <input
                              type="number"
                              name="TokenRoyalities"
                              id="TokenRoyalities"
                              onKeyDown={(evt) =>
                                ["e", "E", "+", "-", ".", ","].includes(
                                  evt.key
                                ) && evt.preventDefault()
                              }
                              onChange={inputChange}
                              autoComplete="off"
                              class="form-control"
                              placeholder="Suggested: 5% (Max 40%)"
                              max="40"
                              min="5"
                              value={TokenRoyalities}
                            />
                            {ValidateError.TokenRoyalities && (
                              <span className="text-danger">
                                <br />
                                {ValidateError.TokenRoyalities}
                              </span>
                            )}
                            <div class="spacer-10"></div>
                            <label className="primary_label">Category</label>
                            <div id="item_category" class="dropdown w-100">
                              <Select
                                id="category"
                                onChange={changeCategory}
                                options={CategoryOption}
                                styles={colourStyles}
                              />

                              {ValidateError.TokenCategory && (
                                <span className="text-danger">
                                  <br />
                                  {ValidateError.TokenCategory}
                                </span>
                              )}
                            </div>
                            <div class="spacer-10"></div>
                            <div className="input_Unlock_section">
                              <div>
                                <label className="primary_label">
                                  Unlockable content
                                </label>
                                <p>
                                  The content is visible only to the current
                                  owner.
                                </p>
                              </div>
                              <label className="switch1 toggle_custom">
                                <input
                                  type="checkbox"
                                  id="unlockoncepurchased"
                                  name="unlockoncepurchased"
                                  onChange={CheckedChange}
                                />
                                <span className="slider"></span>
                              </label>
                            </div>
                            {Unlockoncepurchased && (
                              <div className="unlock_show">
                                <label className="primary_label">
                                  Enter unlockable content
                                </label>
                                <textarea
                                  className="form-control primary_inp"
                                  name="UnLockcontent"
                                  id="UnLockcontent"
                                  onChange={inputChange}
                                  placeholder="Enter unlockable content. E.g. Link, password or instructions etc."
                                  rows="2"
                                ></textarea>
                                {ValidateError.UnLockcontent && (
                                  <span className="text-danger">
                                    {ValidateError.UnLockcontent}
                                  </span>
                                )}
                              </div>
                            )}
                            {/*  <label className="primary_label">
                              Properties <small>(optional)</small>
                            </label>
                            <input
                              type="text"
                              name="TokenProperties"
                              onChange={inputChange}
                              autoComplete="off"
                              id="TokenProperties"
                              class="form-control"
                              placeholder="E.g. size: small, medium & large"
                            /> */}
                            <div class="spacer-10"></div>
                            {CollectiblesType == "Multiple" && (
                              <div>
                                <label className="primary_label">
                                  Number of copies
                                </label>
                                <input
                                  type="number"
                                  onChange={
                                    CollectiblesType == "Single"
                                      ? ""
                                      : inputChange
                                  }
                                  value={TokenQuantity}
                                  onKeyDown={(evt) =>
                                    ["e", "E", "+", "-", "."].includes(
                                      evt.key
                                    ) && evt.preventDefault()
                                  }
                                  name="TokenQuantity"
                                  id="TokenQuantity"
                                  class="form-control"
                                  placeholder="e.g. 1 or 2 or 3"
                                />
                                {ValidateError.TokenQuantity && (
                                  <span className="text-danger">
                                    <br />
                                    {ValidateError.TokenQuantity}
                                  </span>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </form>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="nav-owned"
                      role="tabpanel"
                      aria-labelledby="nav-owned-tab"
                    >
                      <form
                        id="form-create-item"
                        class="form-border"
                        method="post"
                        action="email.php"
                      >
                        <div class="field-set">
                          <label className="primary_label">Upload file</label>

                          <div class="d-create-file">
                            <p id="file_name">
                              PNG, JPG, GIF, WEBP or MP4. Max 200mb.
                            </p>
                            <div className="uploadCustomFile">
                              <input
                                type="button"
                                id="get_file"
                                class="btn-main"
                                value="Browse"
                              />
                              <input type="file" id="upload_file" />
                            </div>
                          </div>

                          <div class="spacer-single"></div>

                          <label className="primary_label">
                            Choose Collections{" "}
                          </label>
                          <div class="de_tab tab_methods">
                            <nav className="mb-4">
                              <div
                                class="nav nav-tabs de_nav createNavTab"
                                id="nav-tab"
                                role="tablist"
                              >
                                <a
                                  class="nav-item nav-link active"
                                  id="nav-fixedPrice-tab"
                                  data-toggle="tab"
                                  href="#nav-fixedPrice"
                                  role="tab"
                                  aria-controls="nav-fixedPrice"
                                  aria-selected="true"
                                >
                                  <span>
                                    <i class="fa fa-tag"></i>Fixed price
                                  </span>
                                </a>
                              </div>
                            </nav>
                          </div>

                          <div class="spacer-single"></div>

                          {putonmarket && (
                            <label className="primary_label">
                              Select method
                            </label>
                          )}
                          <div class="de_tab tab_methods">
                            {putonmarket && (
                              <nav className="mb-4">
                                <div
                                  class="nav nav-tabs de_nav createNavTab"
                                  id="nav-tab"
                                  role="tablist"
                                >
                                  <a
                                    class="nav-item nav-link active"
                                    id="nav-fixedPrice-tab"
                                    data-toggle="tab"
                                    href="#nav-fixedPrice"
                                    role="tab"
                                    aria-controls="nav-fixedPrice"
                                    aria-selected="true"
                                  >
                                    <span>
                                      <i class="fa fa-tag"></i>Fixed price
                                    </span>
                                  </a>
                                  <a
                                    class="nav-item nav-link"
                                    id="nav-timedAuction-tab"
                                    data-toggle="tab"
                                    href="#nav-timedAuction"
                                    role="tab"
                                    aria-controls="nav-timedAuction"
                                    aria-selected="false"
                                  >
                                    <span>
                                      <i class="fa fa-hourglass-1"></i>Timed
                                      auction
                                    </span>
                                  </a>
                                  <a
                                    class="nav-item nav-link"
                                    id="nav-openForBids-tab"
                                    data-toggle="tab"
                                    href="#nav-openForBids"
                                    role="tab"
                                    aria-controls="nav-openForBids"
                                    aria-selected="false"
                                  >
                                    <span>
                                      <i class="fa fa-users"></i>Open for bids
                                    </span>
                                  </a>
                                </div>
                              </nav>
                            )}

                            {putonmarket && (
                              <div class="tab-content" id="nav-tabContent">
                                <div
                                  class="tab-pane fade show active"
                                  id="nav-fixedPrice"
                                  role="tabpanel"
                                  aria-labelledby="nav-home-tab"
                                >
                                  <div id="tab_opt_1">
                                    <label className="primary_label">
                                      Price
                                    </label>
                                    <input
                                      type="text"
                                      name="item_price"
                                      id="item_price"
                                      class="form-control"
                                      placeholder="enter price for one item (ETH)"
                                      value={Price}
                                    />
                                  </div>
                                </div>
                                <div
                                  class="tab-pane fade"
                                  id="nav-timedAuction"
                                  role="tabpanel"
                                  aria-labelledby="nav-profile-tab"
                                >
                                  <div id="tab_opt_2">
                                    <label className="primary_label">
                                      Minimum bid amount
                                    </label>
                                    <input
                                      type="text"
                                      name="item_price_bid"
                                      id="item_price_bid"
                                      class="form-control"
                                      placeholder="enter minimum bid amount"
                                    />

                                    <div class="spacer-10"></div>

                                    <div class="row">
                                      <div class="col-md-6">
                                        <label className="primary_label">
                                          Starting date
                                        </label>
                                        <input
                                          type="date"
                                          name="bid_starting_date"
                                          id="bid_starting_date"
                                          class="form-control"
                                          min="1997-01-01"
                                        />
                                      </div>
                                      <div class="col-md-6">
                                        <label className="primary_label">
                                          Expiration date
                                        </label>
                                        <input
                                          type="date"
                                          name="bid_expiration_date"
                                          id="bid_expiration_date"
                                          class="form-control"
                                        />
                                      </div>
                                      <div class="spacer-single"></div>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  class="tab-pane fade"
                                  id="nav-openForBids"
                                  role="tabpanel"
                                  aria-labelledby="nav-contact-tab"
                                ></div>
                              </div>
                            )}
                            <label className="primary_label">Title</label>
                            <input
                              type="text"
                              name="item_title"
                              id="item_title"
                              class="form-control"
                              placeholder="e.g. 'Name your NFT'"
                            />

                            <div class="spacer-10"></div>
                            <label className="primary_label">Royalty</label>
                            <input
                              type="text"
                              name="item_royalties"
                              id="item_royalties"
                              class="form-control"
                              placeholder="Suggested: 5% (Max 40%)"
                            />
                            <div class="spacer-10"></div>
                            <label className="primary_label">Category</label>
                            <div
                              id="item_category_multiple"
                              class="dropdown w-100"
                            >
                              <a
                                href="javascript:void(0)"
                                class="btn-selector w-100 d-block"
                              >
                                All categories
                              </a>
                              <ul className="w-100">
                                <li class="active">
                                  <span>All categories</span>
                                </li>
                                <li>
                                  <span>Art</span>
                                </li>
                                <li>
                                  <span>Music</span>
                                </li>
                                <li>
                                  <span>Domain Names</span>
                                </li>
                                <li>
                                  <span>Virtual World</span>
                                </li>
                                <li>
                                  <span>Trading Cards</span>
                                </li>
                                <li>
                                  <span>Collectibles</span>
                                </li>
                                <li>
                                  <span>Sports</span>
                                </li>
                                <li>
                                  <span>Utility</span>
                                </li>
                                <li>
                                  <span>Photography</span>
                                </li>
                                <li>
                                  <span>DeFi</span>
                                </li>
                                <li>
                                  <span>Metaverse</span>
                                </li>
                                <li>
                                  <span>Games</span>
                                </li>
                                <li>
                                  <span>Videos</span>
                                </li>
                              </ul>
                            </div>

                            <div class="spacer-10"></div>
                            <label className="primary_label">Description</label>
                            <textarea
                              data-autoresize
                              name="item_desc"
                              id="item_desc"
                              class="form-control"
                              placeholder="e.g.  Write some fascinating story about your NFT"
                            ></textarea>

                            <div class="spacer-10"></div>

                            <label className="primary_label">
                              Properties <small>(Optional)</small>
                            </label>
                            <input
                              type="text"
                              name="item_royalties"
                              id="item_royalties"
                              class="form-control"
                              placeholder="e.g. size: Small, Medium & Large"
                            />

                            <div class="spacer-single"></div>

                            <div class="spacer-single"></div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-3 col-sm-6 col-xs-12">
                <div className="createPreview">
                  <label className="primary_label">Preview item</label>
                  <div class="nft__item">
                    {PutOnSaleType == "TimedAuction" && (
                      <div class="de_countdown">
                        <Countdown
                          date={`${year}-02-28T12:00:00`}
                          renderer={renderer}
                        />
                      </div>
                    )}
                    <div class="author_list_pp">
                      <a href="#">
                        <img class="lazy" src={profileimage} alt="" />
                        {profilestatus && <i class="fa fa-check"></i>}
                      </a>
                    </div>
                    <div class="nft__item_wrap">
                      <a href="#">
                        {/* <img src={require("../assets/images/collections/coll-item-3.jpg")} id="get_file_2" class="lazy nft__item_preview" alt="" /> */}
                        {TokenFilePreUrl.split(".").pop() == "mp4" ? (
                          <video
                            src={
                              TokenFilePreReader != ""
                                ? TokenFilePreReader
                                : `${config.Back_URL}images/previewThumb1.png`
                            }
                            type="video/mp4"
                            id="get_file_2"
                            class="lazy nft__item_preview"
                            alt=""
                            autoPlay
                            playsInLine
                            loop
                            muted
                          ></video>
                        ) : (
                          <div className="text-center">
                            {TokenFilePreUrl.split(".").pop() == "mp3" ? (
                              <div>
                                <img
                                  src={config.Back_URL + "images/music.png"}
                                  id="get_file_2"
                                  class="lazy nft__item_preview"
                                  alt=""
                                />
                                <audio
                                  src={
                                    TokenFilePreReader != ""
                                      ? TokenFilePreReader
                                      : `${config.Back_URL}images/previewThumb1.png`
                                  }
                                  type="audio/mp3"
                                  controls
                                  className="audio home"
                                ></audio>
                              </div>
                            ) : (
                              <img
                                src={
                                  TokenFilePreReader != ""
                                    ? TokenFilePreReader
                                    : `${config.Back_URL}images/previewThumb1.png`
                                }
                                id="get_file_2"
                                class="lazy nft__item_preview"
                                alt=""
                              />
                            )}
                          </div>
                        )}
                      </a>
                    </div>

                    <div class="nft__item_info">
                      <a href="#">
                        <h4>{TokenName}</h4>
                      </a>
                      {PutOnSaleType == "FixedPrice" && putonmarket && (
                        <div class="nft__item_price">
                          {Price} {currencyName}
                          {TokenQuantity != "" && (
                            <span>
                              {TokenQuantity} / {TokenQuantity}
                            </span>
                          )}
                        </div>
                      )}
                      {PutOnSaleType == "TimedAuction" && putonmarket && (
                        <div class="nft__item_price">
                          {MinimumBid} {"WETH"}
                          {TokenQuantity != "" && (
                            <span>
                              {TokenQuantity} / {TokenQuantity}
                            </span>
                          )}
                        </div>
                      )}
                      <div className="nft-item-group">
                        {PutOnSaleType == "FixedPrice" &&
                          putonmarket &&
                          TokenPrice > 0 && (
                            <div class="nft__item_action">
                              <a href="#">Place a bid</a>
                            </div>
                          )}
                        {PutOnSaleType == "TimedAuction" && putonmarket && (
                          <div class="nft__item_action">
                            <a href="#">Minimum bid amount</a>
                          </div>
                        )}
                        {PutOnSaleType == "UnLimitedAuction" && putonmarket && (
                          <div class="nft__item_action">
                            <a href="#">Open for bids</a>
                          </div>
                        )}
                        {/* <div class="nft__item_like">
                          <i class="fa fa-heart"></i>
                          <span>0</span>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-11 offset-lg-1">
                <input
                  type="button"
                  id="submit"
                  class="btn-main"
                  value="Create Item"
                  onClick={CreateItem}
                />
              </div>
            </div>
          </div>
        </section>

        <Footer />

        {/*create model */}
        <div
          className="modal fade primary_modal"
          id="create_item_modal"
          data-backdrop="static"
          tabindex="-1"
          role="dialog"
          aria-labelledby="place_bid_modalCenteredLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
              <div className="modal-header text-center">
                <h5 className="modal-title" id="place_bid_modalLabel">
                  Follow Steps
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div className="modal-body">
                <form className="px-4 bid_form form-border">
                  {!userApproved && (
                    <div class="media approve_media">
                      {ApproveCallStatus == "processing" ? (
                        <i
                          class="fa fa-spinner fa-spin me-2 spinner_icon"
                          aria-hidden="true"
                          id="circle1"
                        ></i>
                      ) : ApproveCallStatus == "done" ? (
                        <i
                          className="fas fa-check me-2 pro_complete"
                          aria-hidden="true"
                        ></i>
                      ) : (
                        <i className="fas fa-check me-2" aria-hidden="true"></i>
                      )}

                      <div class="media-body">
                        <p className="buy_desc_sm">Authorize</p>
                        <p className="buy_desc_sm_bold">
                          Authorize your wallet to perform the transaction
                        </p>
                      </div>
                    </div>
                  )}
                  {!userApproved && (
                    <div className="text-center my-3">
                      <button
                        type="button"
                        onClick={ApproveCall}
                        disabled={
                          ApproveCallStatus == "processing" ||
                          ApproveCallStatus == "done"
                        }
                        className={
                          ApproveCallStatus == "processing" ||
                          ApproveCallStatus == "init"
                            ? "btn-main lead  mar-top-10"
                            : "btn-main btnGrey lead  mar-top-10"
                        }
                      >
                        {ApproveCallStatus == "init" && "Authorize"}
                        {ApproveCallStatus == "processing" && "In-progress..."}
                        {ApproveCallStatus == "done" && "Done"}
                        {ApproveCallStatus == "tryagain" && "Try Again"}
                      </button>
                    </div>
                  )}
                  <div class="media approve_media">
                    {MintCallStatus == "processing" ? (
                      <i
                        class="fa fa-spinner fa-spin me-2 spinner_icon"
                        aria-hidden="true"
                        id="circle1"
                      ></i>
                    ) : MintCallStatus == "done" ? (
                      <i
                        className="fas fa-check me-2 pro_complete"
                        aria-hidden="true"
                      ></i>
                    ) : (
                      <i className="fas fa-check me-2" aria-hidden="true"></i>
                    )}
                    <div class="media-body">
                      <p className="buy_desc_sm">Upload and Mint NFT</p>
                      <p className="buy_desc_sm_bold">
                        Upload your file and mint the NFT
                      </p>
                    </div>
                  </div>
                  <div className="text-center my-3">
                    <button
                      type="button"
                      disabled={
                        ApproveCallStatus != "done" ||
                        MintCallStatus == "processing" ||
                        MintCallStatus == "done"
                      }
                      onClick={MintCall}
                      className={
                        ApproveCallStatus == "done" && MintCallStatus != "done"
                          ? "btn-main lead  mar-top-10"
                          : "btn-main btnGrey lead  mar-top-10"
                      }
                    >
                      {MintCallStatus == "init" && "Mint"}
                      {MintCallStatus == "processing" && "In-progress..."}
                      {MintCallStatus == "done" && "Done"}
                      {MintCallStatus == "tryagain" && "Try Again"}
                    </button>
                  </div>
                  {putonmarket && (
                    <div class="media approve_media">
                      {SignCallStatus == "processing" ? (
                        <i
                          class="fa fa-spinner fa-spin me-2 spinner_icon"
                          aria-hidden="true"
                          id="circle1"
                        ></i>
                      ) : SignCallStatus == "done" ? (
                        <i
                          className="fas fa-check me-2 pro_complete"
                          aria-hidden="true"
                        ></i>
                      ) : (
                        <i className="fas fa-check me-2" aria-hidden="true"></i>
                      )}
                      <div class="media-body">
                        <p className="buy_desc_sm">Sign Sale Order</p>
                        <p className="buy_desc_sm_bold">
                          Sign the sale order to put NFT for Sale.
                        </p>
                      </div>
                    </div>
                  )}
                  {putonmarket && (
                    <div className="text-center my-3">
                      <button
                        type="button"
                        disabled={
                          MintCallStatus != "done" ||
                          SignCallStatus == "processing" ||
                          SignCallStatus == "done"
                        }
                        onClick={SignCall}
                        className={
                          MintCallStatus == "done" && SignCallStatus != "done"
                            ? "btn-main lead  mar-top-10"
                            : "btn-main btnGrey lead  mar-top-10"
                        }
                      >
                        {SignCallStatus == "init" && "Sign"}
                        {SignCallStatus == "processing" && "In-progress..."}
                        {SignCallStatus == "done" && "Done"}
                        {SignCallStatus == "tryagain" && "Try Again"}
                      </button>
                    </div>
                  )}
                  {putonmarket && Unlockoncepurchased && (
                    <div class="media approve_media">
                      {SignLockCallStatus == "processing" ? (
                        <i
                          class="fa fa-spinner fa-spin me-2 spinner_icon"
                          aria-hidden="true"
                          id="circle1"
                        ></i>
                      ) : SignLockCallStatus == "done" ? (
                        <i
                          className="fas fa-check me-2 pro_complete"
                          aria-hidden="true"
                        ></i>
                      ) : (
                        <i className="fas fa-check me-2" aria-hidden="true"></i>
                      )}
                      <div class="media-body">
                        <p className="buy_desc_sm">Sign Unlockable Content</p>
                        <p className="buy_desc_sm_bold">
                          Please provide a signature for unlockable content
                        </p>
                      </div>
                    </div>
                  )}
                  {putonmarket && Unlockoncepurchased && (
                    <div className="text-center mt-3">
                      <button
                        type="button"
                        disabled={
                          SignCallStatus != "done" ||
                          SignLockCallStatus == "processing" ||
                          SignLockCallStatus == "done"
                        }
                        onClick={SignLockCall}
                        className={
                          SignCallStatus == "done" &&
                          SignLockCallStatus != "done"
                            ? "btn-main lead  mar-top-10"
                            : "btn-main btnGrey lead  mar-top-10"
                        }
                      >
                        {SignLockCallStatus == "init" && "Lock"}
                        {SignLockCallStatus == "processing" && "In-progress..."}
                        {SignLockCallStatus == "done" && "Done"}
                        {SignLockCallStatus == "tryagain" && "Try Again"}
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
        {/* date model */}
        <div
          class="modal fade primary_modal"
          id="calendar_modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="calendar_modalCenteredLabel"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-dialog-centered modal-sm"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-module">
                <div class="modal-header text-center">
                  <h5 class="modal-title" id="calendar_modalLabel">
                    Choose date
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    id="cancelcalender"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div className="pb-3">
                    <Datetime
                      minDate={new Date().getTime()}
                      input={false}
                      value={Clocktime}
                      onChange={(value) => set_Clocktime(value)}
                    />
                  </div>
                </div>
                <div class="text-center mb-3">
                  <input
                    type="submit"
                    name="Done"
                    value="Done"
                    className="primary_btn"
                    id="doneStartDate"
                    onClick={() => ModalAction("calendar_modal", "hide")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade primary_modal"
          id="calendar_modal_expire"
          tabindex="-1"
          role="dialog"
          aria-labelledby="calendar_modalCenteredLabel"
          aria-hidden="true"
        >
          <div
            class="modal-dialog modal-dialog-centered modal-sm"
            role="document"
          >
            <div class="modal-content">
              <div class="modal-module">
                <div class="modal-header text-center">
                  <h5 class="modal-title" id="calendar_modalLabel">
                    Choose date
                  </h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    id="cancelcalender"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <div className="pb-3">
                    <Datetime
                      input={false}
                      value={EndClocktime}
                      minDate={new Date().getTime()}
                      onChange={(value) => set_EndClocktime(value)}
                    />
                  </div>
                </div>
                <div class="text-center mb-3">
                  <input
                    type="submit"
                    name="Done"
                    value="Done"
                    className="primary_btn"
                    id="doneEndDate"
                    onClick={() => ModalAction("calendar_modal_expire", "hide")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade primary_modal"
          id="choose_collection_modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="choose_collection_modalCenteredLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
              <div class="modal-header text-center">
                <h5 class="modal-title" id="choose_collection_modalLabel">
                  Collection
                </h5>
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div className="d-flex align-items-center">
                  <div class="hex center">
                    <div class="hex__shape">
                      <div class="hex__shape">
                        <div class="hex__shape">
                          <img
                            src={
                              userimage && userimage != ""
                                ? userimage
                                : require("../assets/images/img_01.png")
                            }
                            alt="logo"
                            className="img-fluid"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p className="font_16 font_600 line_20 mb-1">
                      We recommend an image of at least 400x400. Gifs work too.
                    </p>
                    <div className="file_btn primary_btn d-inline-block">
                      Choose File
                      <input
                        className="inp_file"
                        type="file"
                        name="file"
                        accept="image/*"
                        id="collectionpic"
                        required="true"
                        onChange={handleFilecollection}
                      />
                    </div>
                  </div>
                </div>
                <form class="form-border" autoComplete="off">
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label className="primary_label" htmlFor="name">
                        Collection Name{" "}
                        <span className="text-muted">(30 available)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control primary_inp"
                        id="name"
                        placeholder="Enter token name"
                        name="owncollectionname"
                        onChange={inputChangename}
                        value={owncollectionname}
                        maxLength="30"
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <label className="primary_label" htmlFor="desccription">
                        Symbol <span className="text-muted">(required)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control primary_inp"
                        id="desccription"
                        placeholder="Enter token symbol"
                        name="owncollectionsymbol"
                        onChange={inputChangesymbol}
                        value={owncollectionsymbol}
                      />
                    </div>
                  </div>
                  <div className="form-row">
                    <div className="form-group col-md-12">
                      <label className="primary_label" htmlFor="name">
                        Description{" "}
                        <span className="text-muted">(Optional)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control primary_inp"
                        id="name"
                        placeholder="Tell us something about this collection"
                        onChange={inputChangedescription}
                        value={collectiondescription}
                      />
                    </div>
                    <div className="form-group col-md-12">
                      <label className="primary_label" htmlFor="desccription">
                        Short url <span className="text-muted">(Required)</span>
                      </label>
                      <input
                        type="text"
                        className="form-control primary_inp"
                        id="desccription"
                        defaultValue="http://212.71.233.123/pyramidionscollection/"
                        onChange={inputChangeurl}
                        value={collectionurl}
                        maxLength="100"
                      />
                    </div>
                  </div>
                  <div className="text-center">
                    <button
                      type="button"
                      className="create_btn"
                      onClick={handleFormSubmit}
                      disabled={showloadercollect}
                    >
                      {showloadercollect == true && (
                        <i
                          class="fa fa-spinner fa-spin me-2 spinner_icon"
                          aria-hidden="true"
                          id="circle1"
                        ></i>
                      )}
                      Create collection
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
